import React from 'react';
import {
  Whatshot as WhatshotIcon,
  AcUnit as AcUnitIcon,
  DeviceThermostat as DeviceThermostatIcon,
} from '@mui/icons-material';
import i18n from '../../i18n';

// Escala do insight: 1–5 (>=4 quente, 3 morno, <=2 frio). Falsy = sem temperatura.
export const getTemperatureIcon = (temperature, fontSize = 'small') => {
  if (!temperature) return null;
  if (temperature >= 4) return <WhatshotIcon fontSize={fontSize} />;
  if (temperature === 3) return <DeviceThermostatIcon fontSize={fontSize} />;
  return <AcUnitIcon fontSize={fontSize} />;
};

export const getTemperatureFromInsight = (temperature) => {
  if (!temperature) return '';
  if (temperature >= 4) return i18n.t('chat.filters.hot');
  if (temperature === 3) return i18n.t('chat.filters.warm');
  return i18n.t('chat.filters.cold');
};

export const getTemperatureColorFromInsight = (temperature) => {
  if (!temperature) return 'default';
  if (temperature >= 4) return 'temperatureHot';
  if (temperature === 3) return 'temperatureWarm';
  return 'temperatureCold';
};

// Bucket do filtro de leads (hot/warm/cold) → cor da paleta (mesmas do chip do card).
export const TEMPERATURE_BUCKET_COLORS = {
  hot: 'temperatureHot',
  warm: 'temperatureWarm',
  cold: 'temperatureCold',
};
